var React = require('react');

function Image (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"fill":"currentColor","key":0},React.createElement("path",{"d":"M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z","transform":"translate(-1014 -637) translate(990 480) translate(24 101) translate(0 56)"})),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","transform":"translate(-1014 -637) translate(990 480) translate(24 101) translate(0 56)","key":1})]))))));
}

Image.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Image;

Image.default = Image;
